'use strict';

// eslint-disable-next-line @typescript-eslint/no-inferrable-types
var round = function (value, fixedDecimals) {
    if (fixedDecimals === void 0) { fixedDecimals = 2; }
    var factor = Math.pow(10, fixedDecimals);
    return Math.round(value * factor) / factor;
};
var Numbers = { round: round };

module.exports = Numbers;
